import { Group } from '../group/group.model';
import { PaymentPlanType } from '../payment-plan/payment-plan.model';
import { UserMarkup } from '../user/user.model';

export enum AccountType {
    REGISTERED = 'registered',
        AFFIRMATIVE = 'affirmative',
        TRIAL = 'trial'
}

export class OrganizationPreview {
    id: string | null = null;
    friendlyName: string | null = null;
    accountType: AccountType | null = null;
    isSetupComplete: boolean | null = null;
    paymentPlanType: PaymentPlanType|undefined;
    subscriptionId: string|undefined;
    disabled: boolean | null = null;

    constructor(o: Partial<OrganizationPreview>) {
        Object.keys(this).forEach(key => {
            if(o[key as keyof OrganizationPreview] == null)
                throw new Error(`${key} cannot be null.`);
        });

        if (this.paymentPlanType === PaymentPlanType.INVOICE && this.subscriptionId == null)
            throw new Error('subscriptionId must be populated for invoice plans');
        Object.assign(this, o);
    }
}

export class Organization {

    constructor(organization: Partial<Organization>) {

        Object.keys(this).forEach(key => {
            if (organization[key as keyof Organization] == null && this[key as keyof Organization] == null)
                throw Error(`${key} cannot be null`);
        });
        Object.assign(this, organization);
    }

    id: string | null = null;
    createdAt: Date | null = null;
    updatedAt: Date | null = null;
    apiKey: string | null = null;

    friendlyName: string | null = null;
    isSetupComplete: boolean | null = null;
    disabled: boolean | null = null;
    isSelfServiceReview: boolean | null = null;
    accountType: AccountType | null = null;
    logoUrl: string|undefined;

    initialUserId: string|undefined;

    // BILLING RELATED THINGS
    paymentPlanType: PaymentPlanType|undefined;
    paymentPlanId: string|undefined;

    // ONLY FOR paymentPlanType === CREDITS
    lastBilledDate: Date|undefined;
    nextBillDate: Date|undefined;

    // ONLY FOR paymentPlanType === INVOICE
    billingUserId: string|undefined;

    // ONLY FOR paymentPlanType&&accountType === TRIAL
    remainingDays: number|undefined;
    isTrialClosed: boolean|undefined;

    creditUsageCount: number | null = null;
    remainingCreditCount: number|undefined;
    freeCredits: number | null = null;

    statementsPerMonth: number | null = null;
    totalEmployees: number | null = null;

    // BUY RATES
    buyRates: BuyRates | null = null;

    // DEFAULT USER MARKUP TO BUY RATES
    defaultUserMarkup: UserMarkup | null = null;
    defaultSalesCommissionPercent: number | null = null;

    creditUsageHistory: Array<any>|undefined;

    groups: Array<Group>|undefined;
}

interface BuyRates {
    ratePerTrans: number;
    costPerTrans: number;
    fixedMonthlyFeeTotal: number;
    profitOverCost: number;
}

export interface AccountSelectionModel {
    organization: TempAcctObj | null;
    group: any|undefined;
    team: any|undefined;
}

export interface TempAcctObj {
    id: string;
    name: string;
}
